import { Component } from '@angular/core';

@Component({
	selector: 'ap-angular-redirect',
	templateUrl: './redirect.component.html'
})
export class RedirectComponent {
}
